export default __webpack_public_path__ + "static/media/telegram-white.f66dc427.png";